import { Link } from "react-router-dom";
import { useT } from "@/contexts/I18nContext";
import { useAuth } from "@/contexts/AuthContext";
import { useCallable } from "@/lib/hooks/useCallable";
import { CALLABLES } from "@/services/callables";
import type { LegalStatus } from "@/types";

/**
 * Outstanding documents, said where they will be seen.
 *
 * On the dashboard rather than buried in the legal page, and it states the
 * consequence rather than implying it. An owner who reads "action required"
 * and does nothing has been told something; an owner who reads "lessons cannot
 * be started" has been told the thing that matters.
 */
export function OutstandingBanner() {
  const t = useT();
  const { hasRole } = useAuth();
  const status = useCallable<LegalStatus>(CALLABLES.getLegalStatus);

  const count = status.data?.outstanding.length ?? 0;
  if (count === 0) return null;

  return (
    <div
      role="status"
      className="mb-8 flex flex-wrap items-center justify-between gap-4 rounded-card
                 border border-danger bg-danger-soft px-5 py-4"
    >
      <p className="text-sm text-ink">
        {t(count === 1 ? "legal.outstandingBanner" : "legal.outstandingBannerPlural", { count })}
      </p>
      {/* A teacher can read them; only an owner can accept. Either way the
          link goes to the same page, which says which is which. */}
      <Link
        to="/legal"
        className="text-sm font-medium text-danger underline underline-offset-2"
      >
        {hasRole(["owner"]) ? t("legal.outstandingAction") : t("legal.read")}
      </Link>
    </div>
  );
}
